export default __webpack_public_path__ + "static/media/emoji-camera.58752297.svg";